export const DELETE_USER = 'deleteUser';
export const UPDATE_USER = 'updateUser';
export const UPLOAD_PROFILE_USER_IMAGE = 'uploadProfileUserImage';
export const EXPORT_USER_CELLS = 'exportUserCells';
export const ACCEPT_COOKIES = 'ACCEPT_COOKIES';
export const REGENERATE_USER_SPRITE = 'REGENERATE_USER_SPRITE';
export const SEND_EMAIL = 'SEND_EMAIL';
